import React from "react";

const BrandButton = ({
  children,
  onClick,
  disabled,
  className = "",
  style = {},
  type = "button",
  dataTestId,
  ariaPressed,
  ariaLabel,
  ...rest
}) => {
  // Always apply brand gradient class; consumers can pass extra classes (e.g., spacing)
  const mergedClass =
    `btn d-flex align-items-center justify-content-center fw-bold bg-brand-gradient brand-button ${className}`.trim();

  const mergedStyle = {
    border: "none",
    color: "#000000",
    opacity: disabled ? 0.6 : 1,
    transition: "opacity 150ms ease",
    borderRadius: "9999px",
    padding: "0.5rem 1rem",
    ...style,
  };

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={mergedClass}
      style={mergedStyle}
      data-testid={dataTestId}
      aria-pressed={ariaPressed}
      aria-label={ariaLabel}
      {...rest}
    >
      {children}
    </button>
  );
};

export default BrandButton;
